<template>
  <div>
    <div class="box">
      <div class="nav">
        支护监测
      </div>
      <div class="cont">
        <div class="btn">
        <div class="item" @click="additem">添加设备</div>
      </div>
      <el-table
      height="66vh"
        :data="personList"
        border
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="80">
          <template slot-scope="scope">
										{{(currentPage-1)*pageSize+scope.$index+1}}
									</template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="设备名称"
          width="170">
        </el-table-column>
        <el-table-column
          prop="dtuImei"
          label="设备号"
          width="190">
        </el-table-column>
        <el-table-column
          prop="online"
          label="设备状态"
          width="180">
          <template slot-scope="scope">
            <i :class="scope.row.online==='在线'?'el-icon-success luse':'el-icon-error red'"></i>
            <span :class="scope.row.online==='在线'?'luse':'red'" style="margin-left: 10px">{{ scope.row.online }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="pressureCount1"
          label="压力传感器"
          width="180">
          <template slot-scope="scope">
            <span @click="enter(scope.row.pressureCount2,scope.row)" class="lanse" style="margin-left: 10px">{{ scope.row.pressureCount1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="displacementCount1"
          label="位移传感器"
          width="180">
          <template slot-scope="scope">
            <span @click="enter(scope.row.displacementCount2,scope.row)" class="lanse" style="margin-left: 10px">{{ scope.row.displacementCount1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="dipangleCount1"
          label="倾角传感器"
          width="230">
          <template slot-scope="scope">
            <span @click="enter(scope.row.dipangleCount2,scope.row)" class="lanse" style="margin-left: 10px">{{ scope.row.dipangleCount1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updateDate"
          label="监测日期"
          width="230">
        </el-table-column>
        <el-table-column
          prop="address"
          label="操作">
          <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="success" size="mini">编辑</el-button>
              <el-button @click="delItem(scope.row)" type="warning" size="mini">删除</el-button>
              <el-button type="primary" size="mini" @click="addList(scope.row)">添加传感器</el-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems">
      </el-pagination>
      </div>
      <el-dialog
      top="30vh"
        title="添加传感器"
        :visible.sync="dialogVisible"
        width="35%"
        >
        <div>
          <div class="row" style="padding-left:32px;margin-bottom:20px">
            传感器名称：<div style="width:70%"><el-input v-model="form.name"></el-input></div>
          </div>
          <div class="row" style="padding-left:32px;margin-bottom:20px">
            传感器编号：<div style="width:70%"><el-input v-model="form.num"></el-input></div>
          </div>
          <div class="row" style="padding-left:32px;margin-bottom:20px">
            传感器类型：
              <div style="width:70%;display:flex;justify-content: start;">
                <el-select v-model="value" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addListItem">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
      top="30vh"
        :title="indexB===0?'添加设备':'编辑'"
        :visible.sync="dialogVisible1"
        width="35%"
        >
        <div>
           <div class="row" style="padding-left:32px;margin-bottom:20px">
            设备名称：<div style="width:70%"><el-input v-model="name"></el-input></div>
          </div>
          <div class="row" style="padding-left:32px;margin-bottom:20px">
            设备编号：<div style="width:70%"><el-input v-model="dtuImei"></el-input></div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="addItem">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
  export default {
     data() {
      return {
        options: [],
        value: '',
        form:{
          name:'',
          num:''
        },
        dialogVisible:false,
        dialogVisible1:false,
        tableData: [],
        currentPage: 1, // 表单列表默认页
        pageSize: 10, // 表单列表默认显示数
        groupId:'',
        totalItems:0,
        personList:[],
        userType:'',
        dtuImei:'',
        name:'',
        createBy:'',
        indexB:0,
        row:{}
      }
    },
    mounted(){
      this.groupId = util.session.get('groupId')
      this.userType = util.session.get('roleId')
      this.createBy = util.session.get('user').id
      this.getData()
      this.getDictByType()
    },
    methods:{
      enter(type,item){
        console.log(type,item)
        this.$router.push({
          path:'/highProItem',
          query:{
            tsDtuId:`${item.id}`,
            tsSenserType:`${type}`
          }
        })
      },
      getDictByType(){
        myHttp.getDictByType({
          type: 'monitor_type'
        }).then(res=>{
          console.log(res,'9898')
          this.options = res.data.data.dictList
        })
      },
      addListItem(){
        let that = this
        myHttp.addTsDtuSensor({
          tsDtuId:this.row.id,
          name:this.form.name,
          tsSersorImei:this.form.num,
          tsSersorType:this.value,
          createBy:this.createBy
        }).then(res=>{
          console.log(res)
          if(res.data.code===200){
            that.getData()
            that.$message({
            type: 'success',
            message: `${res.data.msg}`
          })
            that.dialogVisible=false
          }else{
            that.$message({
            type: 'warning',
            message: `${res.data.msg}`
          })
          }
        })
      },
      handleSizeChange(val){
        console.log(val,'1111')
        this.pageSize = val
        this.currentPage = 1
        this.getData()
      },
      handleCurrentChange(val){
        this.currentPage = val
        this.getData()
      },
      delItem(item){
        let that = this
        this.$confirm('此操作将删除该设备, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteTsDtu({
          id:item.id,
          updateBy:this.createBy
        }).then(res=>{
          that.$message({
            type: 'success',
            message: '删除成功!'
          });
          that.getData()
        })
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      addItem(){
        let that = this
        if(this.indexB===0){
            myHttp.addTsDtu({
            groupId:this.groupId,
            userType:this.userType,
            dtuImei:this.dtuImei,
            name:this.name,
            createBy:this.createBy,
            useType:'2'
          }).then(res =>{
            if(res.data.code === 200){
              that.getData()
              that.dialogVisible1 = false
            }else{
              console.log(res)
              that.$message({
                message: `${res.data.msg}`,
                type: 'warning'
              });
            }
          })
        }else{
          myHttp.uptTsDtu({
            id:that.row.id,
            name:that.name,
            dtuImei:that.dtuImei,
            groupId:that.groupId,
            updateBy:that.createBy,
            useType:'2'
          }).then(res =>{
            if(res.data.code === 200){
              that.getData()
              that.dialogVisible1 = false
            }else{
              console.log(res)
              that.$message({
                message: `${res.data.msg}`,
                type: 'warning'
              });
            }
          })
        }
      },
      //获取数据
    getData() {
      var that = this
      myHttp.queryTsDtuByPageList({
          groupId: this.groupId,
          userType:this.userType,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          useType:2
      }).then(
          function (resp) {
            console.log(resp,'999')
            if (resp.data.code == '200') {
              var list = resp.data.data.PageInfo.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].index = (that.currentPage - 1) * that.pageSize + i+1
                let a = list[i].pressureCount.split('_')
                let b = list[i].displacementCount.split('_')
                let c = list[i].dipangleCount.split('_')
                list[i].pressureCount1 = a[0]
                list[i].pressureCount2 = a[1]
                list[i].displacementCount1 = b[0]
                list[i].displacementCount2 = b[1]
                list[i].dipangleCount1 = c[0]
                list[i].dipangleCount2 = c[1]
              }
              that.personList = list
              console.log(that.personList)
              that.totalItems = resp.data.data.PageInfo.total
              if (list.length == 0) {
                that.nodata = true
              }
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function () {}
      )
    },
    //根据type获取状态
    getStatus(warn,type,val){
      var list = warn && warn!=''?JSON.parse(warn):[]
      val = val && val!=''?val:0
      var result = '0'
      for(var i=0;i<list.length;i++){
        if(list[i].tsSersorType==type){
          if(parseFloat(list[i].num)==0 || parseFloat(list[i].num)>=parseFloat(val)){
            result = '0'  //正常
          }else{
            result = '-1'  //异常
          }
        }
      }
      return result
    },
      handleClick(index){
        console.log(index,'999999')
        this.indexB = 1
        this.name = index.name
        this.dtuImei = index.dtuImei
        this.dialogVisible1= true
        this.row = index
      },
      // 添加传感器
      addList(item){
        this.row = item
        this.form.name = ''
        this.form.num = ''
        this.value=''
        this.dialogVisible= true
      },
      additem(){
        this.indexB = 0
        this.dialogVisible1= true
        this.name = ''
        this.dtuImei = ''
      }
    }
  }
</script>

<style  scoped>
.box{
  width: 100%;
  height: 80vh;
  padding-left: 0.417vw;
  padding-right: 1.25vw;
}
.nav{
  height: 60px;
  display: flex;
  justify-content: start;
  align-items: center;
  font-family: PingFang-SC-Regular;
	font-size: 18px;
  color: #000000;
}
.btn{
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: end;
  align-items: center;

  margin-bottom: 
  5px;
}
.btn>.item{
  width: 150px;
	height: 40px;
	background-color: #0b62f0;
	border-radius: 6px;
  font-family: PingFang-SC-Regular;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
  line-height: 40px;
	letter-spacing: 0px;
	color: #ffffff;
  cursor: pointer;
    margin-right: 12px;
}
.btn>.item:hover{
  opacity: 0.7;
}
.luse{
color: rgb(44, 231, 44);
}
.lanse{
  color: rgb(41, 150, 212);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: underline
}
.lanse:hover{
  cursor: pointer;
}
.red{
  color: rgb(230, 65, 36);
}
.row{
  display: flex;
}
.cont{
  width: 100%;
  height: 79vh;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 3px 10px 0px 
		rgba(105, 159, 204, 0.5);
	border-radius: 6px;
  margin-bottom: 1%;
}
</style>